<template>
    <div class='t_content_view'>
        
        <div class="t_export_tip">
            <el-icon><InfoFilled /></el-icon>
            <span>温馨提示：单次「导出有效会话明细」上限 2 万条，超出请缩小时间范围后重试。</span>
        </div>

        <div class="t_search_box" style="margin-bottom: 20px">
            <div class="t_search_select">
                <span style="color: #6D6D6D;">企微主体：</span>
                <el-select style="width: 180px;" multiple size="small" v-model="searchdata.corp_ids"  clearable placeholder="请选择">
                   
                    <el-option v-for="(item,index) in corpList.data" 
                    :key="index"
                    :label="item.corp_name" :value="item.id" />
                </el-select>
            </div>
            <div class="t_search_select" >
                <span class="t_seltitle">选择时间</span>
                <el-select
                    v-model="searchdata.time_type"
                    placeholder=""
                    style="width: 180px;"
                    size="small"
                    :clearable="searchdata.time_type !== defaultTimeType"
                    @change="changetimetype"
                    >
                    <el-option
                        v-for="item in optionstime.data"
                        :key="item.value"
                        :label="item.title"
                        :value="item.value"
                    />
                </el-select>
            </div>
            <div class="t_search_select" v-if="searchdata.time_type=='month'"  style="padding: 1px;"  >
                <!-- <span class="t_seltitle">选择自然月</span> -->
                 <!-- v-if="searchdata.time_type=='month'" -->
                <el-date-picker
                    clearable
                    v-model="searchdata.custom_start"
                    value-format="YYYY-MM"
                    type="month"
                    placeholder="请选择"
                />
            </div>
            <div class="t_search_select" v-if="searchdata.time_type=='custom'" >
                <!-- <span class="t_seltitle">选择自然月</span> -->
                 <!-- v-if="searchdata.time_type=='custom'" -->
                <el-date-picker
                v-model="timeaer"
                @change="changedate"
                type="daterange"
                size="small"
                value-format="YYYY-MM-DD"
                clearable
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                />
            </div>
            <div class="t_search_select" >
                <span class="t_seltitle">选择客服</span>
                <el-select
                    v-model="searchdata.employee_ids"
                    placeholder=""
                    size="small"
                    style="width: 180px;"
                    clearable
                    >
                    <el-option
                        v-for="(item,index) in optionskf.data"
                        :key="index"
                        :label="item.username"
                        :value="item.id"
                    />
                </el-select>
            </div>
            
            <el-button type="primary" color="#F1F3F9" @click="searchbtn()" style="margin-bottom: 10px;">查询</el-button>
            <el-button type="primary" color="#F1F3F9" @click="resetsearch()" style="margin-bottom: 10px;">重置</el-button>
            <el-button @click="exportfrlist"  color="#4F46E5" type="primary" style="margin-bottom: 10px;">导出</el-button>
            <el-button @click="exportvalidlist" class="t_btn_export_detail" style="margin-bottom: 10px;">
                <el-icon style="margin-right: 4px;"><Download /></el-icon>导出有效会话明细
            </el-button>
        </div>
        <div class="t_all_tj_box">
            <div class="t_all_tj">
                <div class="t_all_tj_title">总接入人数</div>
                <div class="t_all_tj_count_box">
                    <div class="t_all_tj_count">{{ tableTj.data.total_access_customers }}</div>
                    <div class="t_all_tj_dw">人</div>
                </div>
            </div>
            <div class="t_all_tj">
                <div class="t_all_tj_title">总会话数</div>
                <div class="t_all_tj_count_box">
                    <div class="t_all_tj_count">{{ tableTj.data.total_sessions }}</div>
                </div>
            </div>
            <div class="t_all_tj">
                <div class="t_all_tj_title">无效会话数</div>
                <div class="t_all_tj_count_box">
                    <div class="t_all_tj_count">{{ tableTj.data.total_invalid_sessions }}</div>
                </div>
            </div>
            <div class="t_all_tj">
                <div class="t_all_tj_title">有效会话数</div>
                <div class="t_all_tj_count_box">
                    <div class="t_all_tj_count">{{ tableTj.data.total_valid_sessions }}</div>
                </div>
            </div>
            <div class="t_all_tj">
                <div class="t_all_tj_title">主动发起会话数</div>
                <div class="t_all_tj_count_box">
                    <div class="t_all_tj_count">{{ tableTj.data.total_active_sessions }}</div>
                </div>
            </div>
            <div class="t_all_tj">
                <div class="t_all_tj_title">平均首次响应时长</div>
                <div class="t_all_tj_count_box">
                    <div class="t_all_tj_count">{{ tableTj.data.avg_first_reply_duration }}</div>
                    <div class="t_all_tj_dw">秒</div>
                </div>
            </div>
            <div class="t_all_tj">
                <div class="t_all_tj_title">平均响应时长</div>
                <div class="t_all_tj_count_box">
                    <div class="t_all_tj_count">{{ tableTj.data.avg_normal_reply_duration
                     }}</div>
                    <div class="t_all_tj_dw">秒</div>
                </div>
            </div>
            <div class="t_all_tj">
                <div class="t_all_tj_title">平均3分钟回复率</div>
                <div class="t_all_tj_count_box">
                    <div class="t_all_tj_count">{{ tableTj.data.reply_in_min_rate }}</div>
                    <!-- <div class="t_all_tj_dw">%</div> -->
                </div>
            </div>
        </div>
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%">
            
            <el-table-column prop="employee_account" label="客服名称" >
                <!-- 自定义标题 -->
                <template #header>
                    <div >客服名称</div>
                </template>
            </el-table-column>
            <el-table-column prop="access_customers" label="接入人数" >
                <!-- 自定义标题 -->
                <template #header>
                    <div >接入人数
                        <el-popover
                            placement="top-start"
                            trigger="hover"
                            :width="400"
                            content="进入到客服接待列表的容户人数，按日去重"
                        >
                            <template #reference>
                                <el-icon><QuestionFilled /></el-icon>
                            </template>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="total_sessions" label="总会话数" >
                <!-- 自定义标题 -->
                <template #header>
                    <div >总会话数
                        <el-popover
                            placement="top-start"
                            trigger="hover"
                            :width="400"
                            content="客服接入的会话总数，总会话数=有效会话数＋无效会话数"
                        >
                            <template #reference>
                                <el-icon><QuestionFilled /></el-icon>
                            </template>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="invalid_sessions" label="无效会话数" >
                <!-- 自定义标题 -->
                <template #header>
                    <div >无效会话数
                        <el-popover
                            placement="top-start"
                            trigger="hover"
                            :width="400"
                            content="在客户进入客服接待列表之后，客服未回复过客户的消息或客户未回复过客服的消息的会话数"
                        >
                            <template #reference>
                                <el-icon><QuestionFilled /></el-icon>
                            </template>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="valid_sessions" label="有效会话数" >
                <!-- 自定义标题 -->
                <template #header>
                    <div >有效会话数
                        <el-popover
                            placement="top-start"
                            trigger="hover"
                            :width="400"
                            content="在客户进入客服接待列表之后，有客服回复客户咨询的会话教，对于客服主动发起的会话必须客户有回复且客服再次回复才算有效会话"
                        >
                            <template #reference>
                                <el-icon><QuestionFilled /></el-icon>
                            </template>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="active_sessions" label="主动发起会话数" >
                <!-- 自定义标题 -->
                <template #header>
                    <div >主动发起会话数
                        <el-popover
                            placement="top-start"
                            trigger="hover"
                            :width="400"
                            content="客服主动发起的会话数，不包括转接入和从待接待列表中主动取出的情况"
                        >
                            <template #reference>
                                <el-icon><QuestionFilled /></el-icon>
                            </template>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="avg_first_reply_duration" label="平均首次响应时长" >
                <!-- 自定义标题 -->
                <template #header>
                    <div >平均首次响应时长
                        <el-popover
                            placement="top-start"
                            trigger="hover"
                            :width="400"
                            content="接入后从客户未命中自动回复的首次询问时间到客服首次回复时间间隔的平均值"
                        >
                            <template #reference>
                                <el-icon><QuestionFilled /></el-icon>
                            </template>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="avg_normal_reply_duration" label="平均响应时长" >
                <!-- 自定义标题 -->
                <template #header>
                    <div >平均响应时长
                        <el-popover
                            placement="top-start"
                            trigger="hover"
                            :width="400"
                            content="响应时长：用户信息到达后的回复等待时间，取平均值"
                        >
                            <template #reference>
                                <el-icon><QuestionFilled /></el-icon>
                            </template>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="reply_in_min_rate" label="3分钟回复率" >
                <!-- 自定义标题 -->
                <template #header>
                    <div >3分钟回复率
                        <el-popover
                            placement="top-start"
                            trigger="hover"
                            :width="400"
                            content="所有接待等待回复不超过3分钟约占比，少手3分钟人数/全部接待数"
                        >
                            <template #reference>
                                <el-icon><QuestionFilled /></el-icon>
                            </template>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
            
        </el-table>
        <!-- 分页 -->
        <!-- <pagechange :total="total" :nowpage="searchdata.pageNo" @page_change="page_change" /> -->
       
    </div>
    
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { ElMessage,ElMessageBox } from 'element-plus'
import { Delete, Edit, Search, Share, Upload ,Plus ,Close} from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { getacclist,delacc,addacc,editacc,chattongji,exporaccjx,newgetjxtime,newgetjxlist,newgetzxlist,newgetczlist,newexportjxlist,newexportvalidjxlist,newgetcomp2} from '@/assets/js/common.js'
//获取路由参数 
const route = useRoute()
//路由跳转
const router = useRouter()

//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    getlist()
    getkefulist()
    getjxtime()
    //获取企微主体下拉
    getcorplist()
})
//企微主体下拉
const corpList = reactive({
    data:[]
})
//获取企微主体下拉
const getcorplist = ()=>{
    newgetcomp2().then((response)=>{
        if (response.data.msg.code == 0) {
            corpList.data = response.data.data
            console.log('企微主体下拉')
            console.log(corpList.data)
        }
    })
}
const getkefulist = ()=>{
    newgetczlist({page:1,page_size:2000,username:''}).then((response)=>{
        if(response.data.msg.code==0){
            console.log('---客服列表')
            console.log(response.data.data.data)
            optionskf.data = response.data.data.data
            
            
        }
    })
}

//时间下拉
const optionstime = reactive({
    data:[]
})

//获取绩效时间列表
const getjxtime = ()=>{
    newgetjxtime().then((response)=>{
        if(response.data.msg.code==0){
            console.log('---绩效时间列表')
            console.log(response.data.data)
            optionstime.data = response.data.data
            
            
        }
    })
}

//客服下拉
const optionskf = reactive({
    data:[]
})

const defaultTimeType = 'yesterday'

//搜索内容
const searchdata  = reactive({
   
    // pageNo:1,
    // pageSize:20,
    time_type:defaultTimeType,
    employee_ids:'',
    custom_start:'',
    custom_end:'',
    corp_ids:'',
})
// 时间段
const timeaer = ref('')
//修改时间段
 const changedate = (val)=>{
    console.log(val)
    if(val){
        searchdata.custom_start = val[0]
        searchdata.custom_end = val[1]
    }else{
        searchdata.custom_start = ''
        searchdata.custom_end = ''
    }
    
 }

//选择时间种类
const changetimetype = (val)=>{
    searchdata.time_type = val || defaultTimeType
    searchdata.custom_start = ''
    searchdata.custom_end = ''
    timeaer.value = ''
}


//搜索
const searchbtn = ()=>{
    // searchdata.pageNo=1

    console.log(searchdata)

    // return

    getlist()
}

//重置
const resetsearch = ()=>{
    
    // searchdata.pageNo=1
    searchdata.custom_start = ''
    searchdata.custom_end = ''
    timeaer.value = ''
    searchdata.time_type = defaultTimeType,
    searchdata.employee_ids = '',
    searchdata.corp_ids = '',
    
    getlist()
}
//列表数据
const tableData = reactive({
    data:[]
})
//统计数据
const tableTj = reactive({
    data:{}
})
//获取列表
const getlist = ()=>{

    console.log('搜索条件--')
    console.log(searchdata)
    if(searchdata.time_type=='month'||searchdata.time_type=='custom'){
        if(!searchdata.custom_start){
            ElMessage({
                message: '请选择时间',
                type: 'warning'
            })
            return
        }
        if(searchdata.time_type=='month'){
            searchdata.custom_end = searchdata.custom_start
        }
        
    }


    var obj = JSON.parse(JSON.stringify(searchdata));
    obj.corp_ids = obj.corp_ids.toString()
    newgetjxlist(obj).then((response)=>{
        if(response.data.msg.code==0){
            console.log('---列表')
            console.log(response.data.data)
            tableData.data = response.data.data.list
            tableTj.data = response.data.data.summary
            
        }
        
    })
}
//成员总数
// const total = ref(0)
//监听分页
// const page_change = (val)=>{
//     searchdata.pageNo = val
//     //人员列表
//     getlist()
// }

//导出列表
const exportfrlist = ()=>{
    if(searchdata.time_type=='month'||searchdata.time_type=='custom'){
        if(!searchdata.custom_start){
            ElMessage({
                message: '请选择时间',
                type: 'warning'
            })
            return
        }
        if(searchdata.time_type=='month'){
            searchdata.custom_end = searchdata.custom_start
        }
        
    }

    var obj = JSON.parse(JSON.stringify(searchdata));
    obj.corp_ids = obj.corp_ids.toString()
    newexportjxlist(obj).then((response)=>{
        if(response.data.msg.code==0){
            console.log('---导出')
            console.log(response.data.data)
            window.open(response.data.data.url,'_blank') 
        }
        
    })





    // var exportL = JSON.parse(JSON.stringify(searchdata));
    // exportL.corpId  = $cookies.get("fanscorpId")
    
    // var str = '?'
    // for (let key in exportL) {
    //     str=str+key+'='+exportL[key]+'&'
    //     // if(exportL[key]==''||exportL[key]==null){
    //     //     str=str+key+'=&'
    //     // }else{
            
    //     // }
        
    // }
    // console.log( str.slice(0, -1))
    // const a = document.createElement('a');
    // a.setAttribute('download', '');
    // a.setAttribute('href', _url2 + `/work/bcCompanyCustomer/performanceManagementListExport`+ str.slice(0, -1));
    // a.click();
    
}

//导出有效会话明细
const exportvalidlist = ()=>{
    if(searchdata.time_type=='month'||searchdata.time_type=='custom'){
        if(!searchdata.custom_start){
            ElMessage({
                message: '请选择时间',
                type: 'warning'
            })
            return
        }
        if(searchdata.time_type=='month'){
            searchdata.custom_end = searchdata.custom_start
        }
    }

    var obj = JSON.parse(JSON.stringify(searchdata));
    obj.corp_ids = obj.corp_ids.toString()
    newexportvalidjxlist(obj).then((response)=>{
        if(response.data.msg.code==0){
            window.open(response.data.data.url,'_blank')
        }
    })
}

</script>
<style scoped>


:deep(.t_search_select .select-trigger) {
    width:100%
}

:deep(.t_search_box .el-input__wrapper ) {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
.t_form_item{
    background-color: #F1F3F9;
    display: flex;
    align-items: center;
    padding-left: 10px;
    margin-bottom: 20px;
}
:deep(.t_form_item .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
    
}
:deep(.t_form_item .el-input)  {
    width: 300px;
    
}
.t_form_title{
    width: 80px;
    text-align: right;
}
.t_form_title span{
   color: #F56C6C;
}
.t_all_tj_box{
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}
.t_all_tj{
    border: 1px solid #F3F3F5;
    padding: 15px 15px 8px 15px;
    box-sizing: border-box;
    flex-grow: 1;
    flex-shrink: 1;
    margin-left: 20px;
}
.t_all_tj:first-child{
    margin-left: 0;
}
.t_all_tj_title{
    font-size: 15px;
    margin-bottom: 10px;
}
.t_all_tj_count_box{
    display: flex;
    align-items: baseline;
}
.t_all_tj_count{
    font-size: 33px;
}
.t_all_tj_dw{
    font-size: 13px;
    color: #6D6D6D;
    margin-left: 5px;
}
.t_seltitle{
    color: #6D6D6D;
    font-size: 13px;
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
/* 导出上限提示 */
.t_export_tip {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 14px;
    padding: 9px 14px;
    border-radius: 8px;
    background: rgba(245, 158, 11, .10);
    border: 1px solid rgba(245, 158, 11, .25);
    color: #92400E;
    font-size: 12.5px;
    font-weight: 500;
}
.t_export_tip .el-icon {
    color: #F59E0B;
    font-size: 14px;
}
/* 有效会话明细导出：次级操作，主色浅底描边，避免与查询/重置混淆 */
.t_btn_export_detail {
    --el-button-bg-color: var(--el-color-primary-light-9);
    --el-button-border-color: var(--el-color-primary-light-5);
    --el-button-text-color: var(--el-color-primary);
    --el-button-hover-bg-color: var(--el-color-primary-light-8);
    --el-button-hover-border-color: var(--el-color-primary-light-3);
    --el-button-hover-text-color: var(--el-color-primary-dark-2);
    --el-button-active-bg-color: var(--el-color-primary-light-7);
    --el-button-active-border-color: var(--el-color-primary-light-3);
    --el-button-active-text-color: var(--el-color-primary-dark-2);
}
</style>